import request from './request'
import * as http from '@/libs/http'

/**
 * ユーザの個人情報を更新する
 *
 * @param {Number} uid ユーザID
 * @param {Object} profile 個人情報
 * @returns {Response} レスポンスデータ
 */
export function putUserProfile (uid, profile) {
  return request.put(`/users/${uid}/profile`, profile, {
    validateStatus: (status) => [
      http.OK
    ].includes(status)
  })
}
